export function useRouter() {
    return useRouter._impl();
}
useRouter._impl = () => ({
    isReady: false,
    href: globalThis.location?.href || '/',
    pathname: globalThis.location?.pathname || '/',
    query: {},
    push: () => {
        // Do nothing
    },
    replace: () => {
        // Do nothing
    },
    back: () => {
        // Do nothing
    },
});
useRouter.setup = (impl) => {
    useRouter._impl = impl;
};
//# sourceMappingURL=useRouter.js.map